// AddPointModal.js
import React, { useState } from 'react';
import axios from 'axios';

const AddPointModal = ({ onClose, onAdd }) => {
    const [name, setName] = useState('');
    const [address, setAddress] = useState('');
    const [latitude, setLatitude] = useState('');
    const [longitude, setLongitude] = useState('');
    const [phone, setPhone] = useState('');
    const [workingHours, setWorkingHours] = useState('');
    const [urlImage, setUrlImage] = useState('');

    const handleAdd = () => {
        axios.post('https://api.alertapp.kz/api/v1/points', {
            name, address, latitude, longitude, phone, workingHours, urlImage
        }, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })
            .then(response => {
                onAdd(response.data);
                onClose();
            })
            .catch(error => console.error('Error adding point:', error));
    };

    return (
        <div className="modal">
            <div className="modal-content">
                <button className="close-button" onClick={onClose}>×</button>
                <h2>Добавить новую точку</h2>
                <input type="text" placeholder="Название" value={name} onChange={(e) => setName(e.target.value)} />
                <input type="text" placeholder="Адрес" value={address} onChange={(e) => setAddress(e.target.value)} />
                <input type="text" placeholder="Широта" value={latitude} onChange={(e) => setLatitude(e.target.value)} />
                <input type="text" placeholder="Долгота" value={longitude} onChange={(e) => setLongitude(e.target.value)} />
                <input type="text" placeholder="Телефон" value={phone} onChange={(e) => setPhone(e.target.value)} />
                <input type="text" placeholder="Часы работы" value={workingHours} onChange={(e) => setWorkingHours(e.target.value)} />
                <input type="text" placeholder="URL изображения" value={urlImage} onChange={(e) => setUrlImage(e.target.value)} />
                <button onClick={handleAdd} className="submit-button">Добавить</button>
            </div>
        </div>
    );
};

export default AddPointModal;
